import {Property} from "../models/Property";
import {BuildArea} from "../models/BuildArea";
import {getPropertyTabGroups, PropertyTabGroup} from "./propertyTabs";

/**
 * The widget tabs are addressed by key, so no one has to know in which position a tab is.
 * The active key lives in TabsContext.
 */
export type TabKey = string

// the first tab: the building area, or the property of a single property widget
export const MAIN_TAB: TabKey = 'main'

export const propertyTabKey = (propertyId: string): TabKey => `property:${propertyId}`

const groupTabKey = (group: PropertyTabGroup): TabKey => `group:${group.labelKey}`

export type WidgetTab =
  | { key: TabKey, kind: 'buildingArea' }
  | { key: TabKey, kind: 'group', group: PropertyTabGroup }
  | { key: TabKey, kind: 'property', property: Property }

/**
 * A building area has its own tab, then a tab per property group, then a tab per property.
 * A single property widget only has the tab of the property.
 */
export const buildTabs = (buildingArea: BuildArea | undefined, properties: Property[]): WidgetTab[] => {
  if (!buildingArea) {
    return properties.map((property) => ({key: MAIN_TAB, kind: 'property', property}))
  }
  return [
    {key: MAIN_TAB, kind: 'buildingArea'},
    ...getPropertyTabGroups(buildingArea.id, properties)
      .map((group): WidgetTab => ({key: groupTabKey(group), kind: 'group', group})),
    ...properties
      .map((property): WidgetTab => ({key: propertyTabKey(property.id), kind: 'property', property})),
  ]
}
